import Sb from './DPC_secondary/DPC_secondary_button'
import BackButton from './back/back_button'

import BaseButton from './base/base_button'
import BorderButton from './border/border_button'
import MainButton from './main/main_button'
import SecondaryButton from './secondary/secondary_button'
import CancelButton from './cancel/cancel_button'
import WarningButton from './warning/warning_button'
import AnimatedToolbarButton from './animated_toolbar_button/animated_toolbar_button'
import GoogleLoginButton from './google_login/google_login_button'
import Office365LoginButton from './office_365_login/office_365_login_button'

import CallToActionDecorator from 'decorators/cta/cta_decorator'

const DPC_SecondaryButton = CallToActionDecorator(Sb)

export {
	DPC_SecondaryButton,
	BackButton,
	BaseButton,
	BorderButton,
	MainButton,
	SecondaryButton,
	CancelButton,
	WarningButton,
	AnimatedToolbarButton,
	GoogleLoginButton,
	Office365LoginButton,
}
